const initialState = {
  dataSearchOutstandingInvoice: {
    storedValues: {
      invoiceNumber: "",
    },
    storedPage: 1,
  },
};

const outstandingInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DATA_SEARCH_OUTSTANDING_INVOICE":
      return {
        ...state,
        dataSearchOutstandingInvoice: action.payload,
      };
    case "RESET_OUTSTANDING_INVOICE":
      return (state = initialState);
    default:
      return state;
  }
};

export default outstandingInvoiceReducer;
